import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { useAuth } from './composables/useAuth';

const app = createApp(App);

// Initialiser l'authentification avant de monter l'app
const { initialize } = useAuth();
initialize().then(() => {
  app.use(router);
  app.mount('#app');
});
